(function () {
  'use strict';

  var initialized = 'orbitInitialized';

  function initAll() {
    var roots = document.querySelectorAll('[data-orbit]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset[initialized] === 'true') return;

      root.dataset[initialized] = 'true';
      initOrbit(root);
    });
  }

  function initOrbit(root) {
    var stage = root.querySelector('[data-ob-stage]');
    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-ob-item]')
    );

    if (!stage || !items.length) return;

    var centerEl = root.querySelector('[data-ob-center]');
    var frame = root.querySelector('[data-ob-frame]');
    var heroImg = root.querySelector('[data-ob-hero-img]');
    var imgLink = root.querySelector('[data-ob-imglink]');
    var textLink = root.querySelector('[data-ob-textlink]');
    var counter = root.querySelector('[data-ob-counter]');
    var nameEl = root.querySelector('[data-ob-name]');
    var priceEl = root.querySelector('[data-ob-price]');
    var phPrev = root.querySelector('[data-ob-photo-prev]');
    var phNext = root.querySelector('[data-ob-photo-next]');
    var phCount = root.querySelector('[data-ob-photo-count]');
    var infoBelow = root.querySelector('[data-ob-info-below]');

    if (
      !centerEl ||
      !frame ||
      !heroImg ||
      !imgLink ||
      !textLink ||
      !counter ||
      !nameEl ||
      !priceEl ||
      !phPrev ||
      !phNext ||
      !phCount ||
      !infoBelow
    ) {
      return;
    }

    var count = items.length;
    var step = 360 / count;

    var rot = 0;
    var target = 0;
    var active = -1;
    var raf = null;
    var moved = 0;

    var photos = [];
    var photoIndex = 0;

    var R = 0;

    var reduce = false;

    if (
      typeof window.matchMedia === 'function'
    ) {
      reduce = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
    }

    var cs = window.getComputedStyle(root);

    var radiusPct =
      parseFloat(
        cs.getPropertyValue('--ob-radius-pct')
      ) || 42;

    var gapPct =
      parseFloat(
        cs.getPropertyValue('--ob-gap-pct')
      ) || 6;

    var SQ = Math.SQRT2;

    /* ---------------------------------------------------------------
       Layout
    --------------------------------------------------------------- */

    var COMPACT_AT = 520;
    var compact = false;

    var textBelowMobile =
      root.dataset.textBelowMobile === 'true';

    /*
      The setting is stored on the section through Liquid below.
      If the attribute is not available, infer the current setting
      from the DOM behavior by defaulting to true.
    */
    if (
      !root.hasAttribute('data-text-below-mobile')
    ) {
      textBelowMobile = true;
    }

    var autoSize = root.dataset.autoSizeItems === 'true';

    var minCenterPct =
      parseFloat(
        root.dataset.minCenterPct
      ) || 45;

    function setCompact(on) {
      if (on === compact) return;

      compact = on;

      root.classList.toggle(
        'is-compact',
        on
      );

      if (on) {
        infoBelow.appendChild(textLink);
      } else {
        centerEl.appendChild(textLink);
      }
    }

    function layout() {
      var s = stage.offsetWidth;

      if (!s) return;

      setCompact(
        textBelowMobile &&
        s < COMPACT_AT
      );

      var half = s / 2;

      var gap =
        s * (gapPct / 100);

      var maxPx =
        parseFloat(
          cs.getPropertyValue(
            '--ob-item-max-px'
          )
        ) || 120;

      var probe =
        parseFloat(
          cs.getPropertyValue(
            compact
              ? '--ob-item-mobile'
              : '--ob-item'
          )
        ) || s * 0.1;

      /*
        Reserve a minimum share of the stage for
        the centre product.
      */
      var share =
        (
          minCenterPct +
          (compact ? 8 : 0)
        ) / 100;

      var aShare =
        Math.max(
          12,
          (
            half *
              (1 - share) -
            gap -
            2
          ) / 2
        );

      var w;

      if (autoSize) {
        /*
          Largest item the ring can seat at this
          product count, then backed off slightly.
        */
        var s0 =
          Math.sin(
            Math.PI / count
          );

        var aIdeal =
          (
            (half - 2) * s0
          ) /
          (1 + s0) *
          0.88;

        w =
          Math.min(
            aIdeal,
            aShare
          ) * SQ;
      } else {
        w =
          Math.min(
            probe,
            aShare * SQ
          );
      }

      w =
        Math.max(
          24,
          Math.min(
            w,
            maxPx,
            compact
              ? s * 0.24
              : maxPx
          )
        );

      /*
        Safety net: shrink further if neighbours
        would still collide.
      */
      for (
        var pass = 0;
        pass < 2;
        pass++
      ) {
        var itemHalfDiag =
          (w * SQ) / 2;

        R =
          Math.min(
            half -
              itemHalfDiag -
              2,
            s *
              (radiusPct / 100)
          );

        var needed =
          itemHalfDiag /
          Math.sin(
            Math.PI / count
          );

        if (
          needed > R &&
          needed > 0
        ) {
          w =
            w *
            (R / needed) *
            0.98;
        }
      }

      var itemHalfDiag2 =
        (w * SQ) / 2;

      R =
        Math.min(
          half -
            itemHalfDiag2 -
            2,
          s *
            (radiusPct / 100)
        );

      root.style.setProperty(
        '--ob-item-w',
        w.toFixed(1) + 'px'
      );

      var r2 =
        R -
        itemHalfDiag2 -
        gap;

      var centreW =
        Math.max(
          90,
          Math.min(
            (r2 * 2) / SQ,
            s * 0.72
          )
        );

      root.style.setProperty(
        '--ob-center-w',
        centreW.toFixed(1) + 'px'
      );

      root.style.setProperty(
        '--ob-center-img',
        (
          centreW *
          (compact ? 1 : 0.88)
        ).toFixed(1) + 'px'
      );

      place();
      fitHeight(r2);
    }

    function fitHeight(r2) {
      var allowed =
        (r2 * 2) / SQ;

      var imgH =
        parseFloat(
          getComputedStyle(root)
            .getPropertyValue(
              '--ob-center-img'
            )
        );

      /*
        A few passes account for the fact that
        shrinking the image can change total
        centre height.
      */
      for (
        var pass = 0;
        pass < 3;
        pass++
      ) {
        var h =
          centerEl.offsetHeight;

        if (h <= allowed) break;

        imgH =
          Math.max(
            70,
            imgH -
              (h - allowed)
          );

        root.style.setProperty(
          '--ob-center-img',
          imgH.toFixed(1) + 'px'
        );
      }
    }

    function place() {
      items.forEach(
        function (el, i) {
          var a =
            (
              i * step +
              rot -
              90
            ) *
            Math.PI /
            180;

          el.style.transform =
            'translate(' +
            'calc(-50% + ' +
            (
              R *
              Math.cos(a)
            ).toFixed(2) +
            'px), ' +
            'calc(-50% + ' +
            (
              R *
              Math.sin(a)
            ).toFixed(2) +
            'px))';
        }
      );
    }

    function indexAt() {
      return (
        (
          -Math.round(
            rot / step
          )
        ) %
          count +
        count
      ) % count;
    }

    /* ---------------------------------------------------------------
       Photo cycling
    --------------------------------------------------------------- */

    function showPhoto(n) {
      if (!photos.length) return;

      photoIndex =
        (
          n % photos.length +
          photos.length
        ) % photos.length;

      frame.classList.add(
        'is-swapping'
      );

      window.setTimeout(
        function () {
          heroImg.src =
            photos[photoIndex];

          frame.classList.remove(
            'is-swapping'
          );
        },
        reduce ? 0 : 140
      );

      phCount.textContent =
        (
          photoIndex + 1
        ) +
        ' / ' +
        photos.length;
    }

    function setActive(i) {
      if (
        i === active &&
        heroImg.src
      ) {
        return;
      }

      active = i;

      var el = items[i];

      items.forEach(
        function (x, n) {
          x.classList.toggle(
            'is-active',
            n === i
          );
        }
      );

      counter.textContent =
        String(i + 1).padStart(
          2,
          '0'
        ) +
        ' / ' +
        String(count).padStart(
          2,
          '0'
        );

      imgLink.setAttribute(
        'href',
        el.dataset.url
      );

      imgLink.setAttribute(
        'aria-label',
        'View ' +
          el.dataset.title
      );

      textLink.setAttribute(
        'href',
        el.dataset.url
      );

      try {
        photos =
          JSON.parse(
            el.dataset.images
          ) || [];
      } catch (e) {
        photos = [];
      }

      centerEl.classList.toggle(
        'has-photos',
        photos.length > 1
      );

      centerEl.classList.add(
        'is-swapping'
      );

      window.setTimeout(
        function () {
          nameEl.textContent =
            el.dataset.title;

          priceEl.textContent =
            el.dataset.price;

          heroImg.alt =
            el.dataset.title;

          centerEl.classList.remove(
            'is-swapping'
          );
        },
        reduce ? 0 : 140
      );

      photoIndex = 0;

      if (photos.length) {
        heroImg.src =
          photos[0];

        phCount.textContent =
          '1 / ' +
          photos.length;
      } else {
        heroImg.removeAttribute(
          'src'
        );

        phCount.textContent = '';
      }
    }

    /* ---------------------------------------------------------------
       Motion
    --------------------------------------------------------------- */

    function settle() {
      if (raf) {
        window.cancelAnimationFrame(
          raf
        );
      }

      if (reduce) {
        rot = target;
        place();
        setActive(indexAt());
        return;
      }

      (function tick() {
        rot +=
          (target - rot) *
          0.2;

        if (
          Math.abs(
            target - rot
          ) < 0.05
        ) {
          rot = target;
          place();
          setActive(
            indexAt()
          );
          startSpin();
          return;
        }

        place();
        setActive(
          indexAt()
        );

        raf =
          window.requestAnimationFrame(
            tick
          );
      })();
    }

    function goTo(i) {
      stopSpin();

      var want =
        -i * step;

      while (
        want - rot >
        180
      ) {
        want -= 360;
      }

      while (
        want - rot <
        -180
      ) {
        want += 360;
      }

      target = want;
      settle();
    }

    /* ---------------------------------------------------------------
       Auto-spin
    --------------------------------------------------------------- */

    var spinRaf = null;
    var lastT = 0;

    var spinOn =
      root.dataset.autospin ===
        'true' &&
      !reduce;

    var spinMs =
      parseInt(
        root.dataset.autospinMs,
        10
      ) || 5000;

    var degPerSec =
      step /
      (spinMs / 1000);

    function glide(t) {
      if (!lastT) {
        lastT = t;
      }

      var dt =
        Math.min(
          0.05,
          (t - lastT) / 1000
        );

      lastT = t;

      rot -=
        degPerSec * dt;

      if (rot < -360) {
        rot += 360;
      }

      place();
      setActive(
        indexAt()
      );

      spinRaf =
        window.requestAnimationFrame(
          glide
        );
    }

    function startSpin() {
      if (
        !spinOn ||
        spinRaf ||
        dragging
      ) {
        return;
      }

      lastT = 0;

      spinRaf =
        window.requestAnimationFrame(
          glide
        );
    }

    function stopSpin() {
      if (spinRaf) {
        window.cancelAnimationFrame(
          spinRaf
        );

        spinRaf = null;
        lastT = 0;
      }
    }

    /* ---------------------------------------------------------------
       Hover / focus / visibility
    --------------------------------------------------------------- */

    root.addEventListener(
      'mouseenter',
      stopSpin
    );

    root.addEventListener(
      'mouseleave',
      startSpin
    );

    root.addEventListener(
      'focusin',
      stopSpin
    );

    root.addEventListener(
      'focusout',
      function () {
        /*
          Restart only when focus has actually
          left the Orbit component.
        */
        window.setTimeout(
          function () {
            if (
              !root.contains(
                document.activeElement
              )
            ) {
              startSpin();
            }
          },
          0
        );
      }
    );

    document.addEventListener(
      'visibilitychange',
      function () {
        if (
          document.hidden
        ) {
          stopSpin();
        } else {
          startSpin();
        }
      }
    );

    /* ---------------------------------------------------------------
       Drag
    --------------------------------------------------------------- */

    var dragging = false;
    var lastA = 0;
    var wasDragged = false;

    function pointerAngle(e) {
      var r =
        stage.getBoundingClientRect();

      return (
        Math.atan2(
          e.clientY -
            (
              r.top +
              r.height / 2
            ),
          e.clientX -
            (
              r.left +
              r.width / 2
            )
        ) *
        180 /
        Math.PI
      );
    }

    stage.addEventListener(
      'pointerdown',
      function (e) {
        if (
          e.button !== undefined &&
          e.button !== 0
        ) {
          return;
        }

        dragging = true;
        moved = 0;
        wasDragged = false;

        lastA =
          pointerAngle(e);

        if (raf) {
          window.cancelAnimationFrame(
            raf
          );
        }

        stopSpin();

        /*
          Intentionally no setPointerCapture.
          Capturing the pointer can retarget
          click events away from the product
          buttons and links.
        */
      }
    );

    window.addEventListener(
      'pointermove',
      function (e) {
        if (!dragging) return;

        var a =
          pointerAngle(e);

        var d =
          a - lastA;

        if (d > 180) {
          d -= 360;
        }

        if (d < -180) {
          d += 360;
        }

        lastA = a;

        rot += d;

        moved +=
          Math.abs(d);

        if (moved >= 4) {
          wasDragged = true;
        }

        place();
        setActive(
          indexAt()
        );
      }
    );

    function end() {
      if (!dragging) return;

      dragging = false;

      target =
        Math.round(
          rot / step
        ) * step;

      settle();
      startSpin();
    }

    window.addEventListener(
      'pointerup',
      end
    );

    window.addEventListener(
      'pointercancel',
      end
    );

    /* ---------------------------------------------------------------
       Product clicks
    --------------------------------------------------------------- */

    items.forEach(
      function (el) {
        el.addEventListener(
          'click',
          function () {
            if (!wasDragged) {
              goTo(
                parseInt(
                  el.dataset.index,
                  10
                )
              );
            }

            wasDragged = false;
            moved = 0;
          }
        );
      }
    );

    imgLink.addEventListener(
      'click',
      function (e) {
        if (wasDragged) {
          e.preventDefault();

          wasDragged = false;
          moved = 0;
        }
      }
    );

    textLink.addEventListener(
      'click',
      function (e) {
        if (wasDragged) {
          e.preventDefault();

          wasDragged = false;
          moved = 0;
        }
      }
    );

    /* ---------------------------------------------------------------
       Photo controls
    --------------------------------------------------------------- */

    phPrev.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        stopSpin();

        showPhoto(
          photoIndex - 1
        );
      }
    );

    phNext.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        stopSpin();

        showPhoto(
          photoIndex + 1
        );
      }
    );

    /* ---------------------------------------------------------------
       Keyboard controls
    --------------------------------------------------------------- */

    stage.addEventListener(
      'keydown',
      function (e) {
        if (
          e.key ===
            'ArrowRight' ||
          e.key ===
            'ArrowDown'
        ) {
          e.preventDefault();

          goTo(
            (active + 1) %
              count
          );
        }

        if (
          e.key ===
            'ArrowLeft' ||
          e.key ===
            'ArrowUp'
        ) {
          e.preventDefault();

          goTo(
            (
              active -
              1 +
              count
            ) % count
          );
        }
      }
    );

    /* ---------------------------------------------------------------
       Resize
    --------------------------------------------------------------- */

    var resizeTimer = null;

    function handleResize() {
      if (resizeTimer) {
        window.cancelAnimationFrame(
          resizeTimer
        );
      }

      resizeTimer =
        window.requestAnimationFrame(
          function () {
            resizeTimer = null;
            layout();
          }
        );
    }

    window.addEventListener(
      'resize',
      handleResize
    );

    /* ---------------------------------------------------------------
       Shopify Theme Editor support
    --------------------------------------------------------------- */

    document.addEventListener(
      'shopify:section:unload',
      function (event) {
        if (
          event.target === root ||
          root.contains(event.target)
        ) {
          stopSpin();

          if (raf) {
            window.cancelAnimationFrame(
              raf
            );
          }
        }
      }
    );

    /* ---------------------------------------------------------------
       Initial state
    --------------------------------------------------------------- */

    layout();
    setActive(0);
    startSpin();
  }

  /*
    Normal storefront page.
  */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /*
    Shopify Theme Editor can dynamically
    insert/re-render sections without a
    full page reload.
  */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initAll();
    }
  );
})();